const PATH_PREFIX = '/subdirectory/:companyID';

export default [
  {
    name: 'subdirectory.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'subdirectory.list',
    path: `${PATH_PREFIX}/list`,
  },
  {
    name: 'subdirectory.detail',
    path: `${PATH_PREFIX}/:docID/detail`,
  },
  {
    name: 'subdirectory.theme',
    path: `${PATH_PREFIX}/:docID/theme`,
  },
  {
    name: 'subdirectory.logo',
    path: `${PATH_PREFIX}/:docID/logo`,
  },
  {
    name: 'subdirectory.banner',
    path: `${PATH_PREFIX}/:docID/banner`,
  },
  {
    name: 'subdirectory.banner.detail',
    path: `${PATH_PREFIX}/:docID/banner/:bannerID`,
  },
  {
    name: 'subdirectory.pageSetting.home',
    path: `${PATH_PREFIX}/:docID/page/setting/home`,
  },
  {
    name: 'subdirectory.siteSetting',
    path: `${PATH_PREFIX}/:docID/site/setting`,
  },
  {
    name: 'subdirectory.company',
    path: `${PATH_PREFIX}/:docID/company`,
  },
];
